var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpEmpty333558000000(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6 12v-6h4v-4h-5c-1.6484 0-3 1.3516-3 3v7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 6h6v4h4v-5c0-1.6484-1.3516-3-3-3h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 2h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 2h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 2h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 2h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 2h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76 2h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 16h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 28h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 40h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 52h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 64h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 76h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 78h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 66h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 54h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 42h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 30h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 18h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 88v6h-4v4h5c1.6484 0 3-1.3516 3-3v-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 94h-6v-4h-4v5c0 1.6484 1.3516 3 3 3h7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78 94h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 94h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 94h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 94h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 94h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 94h6v4h-6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpEmpty333558000000);
export default __webpack_public_path__ + "static/media/np_empty_333558_000000.c85a42816322d788d00cebb87a37ca03.svg";
export { ForwardRef as ReactComponent };